export const DEFAULT_ENRICHMENTS_LIMIT = 1000;
export const ENRICHMENT_RULE_UID_LABEL_PREFIX = 'enrichment-rule.uid';
export const GLOBAL_ENRICHMENT_SCOPE_LABEL_SELECTOR = 'enrichment-scope=global';
